<template>
  <div>
    <b-modal class="stepped-modal" :can-cancel="false" :active="active">
      <div
        class="
          inner
          tw-bg-white
          tw-mx-auto
          tw-min-h-full
          tw-py-5
          tw-flex
          tw-flex-col
          tw-relative
          xl:tw-max-w-[950px]
          xl:tw-w-10/12
          xl:tw-rounded-3xl
          xl:tw-py-10
          xl:tw-px-14
        "
      >
        <CloseIcon
          v-if="currentStep > 1"
          aria-role="button"
          aria-label="Close"
          class="
            tw-hidden tw-absolute tw-top-6 tw-right-7 tw-cursor-pointer
            xl:tw-block
          "
          @click="$emit('close')"
        />
        <header class="xl:tw-w-min stepped-modal-heading">
          <h1
            v-if="title"
            class="
              tw-font-medium
              tw-mb-1
              tw-text-center
              tw-text-xl
              tw-text-gray-title
              xl:tw-mb-2 xl:tw-text-4xl xl:tw-text-left xl:tw-w-max
            "
          >
            {{ title }}
          </h1>
          <p
            v-if="description"
            class="
              tw-font-medium
              tw-hidden
              tw-text-gray-subtitle
              tw-text-center
              tw-text-xs
              xl:tw-block xl:tw-text-left xl:tw-text-lg
            "
          >
            {{ description }}
          </p>
        </header>

        <main class="stepped-modal-content"><slot /></main>

        <footer
          class="
            stepped-modal-steps
            tw-flex tw-justify-center tw-space-x-2 tw-mb-3
            xl:tw-mb-0
          "
        >
          <div
            v-for="i in stepsCount"
            :key="i"
            :class="i === currentStep && 'tw-bg-secondary'"
            class="
              tw-border
              tw-border-secondary
              tw-rounded-full
              tw-h-[7px]
              tw-w-[7px]
              xl:tw-h-[10px] xl:tw-w-[10px]
            "
          />
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CloseIcon from '@/assets/icons/close.svg?inline'

export default {
  components: { CloseIcon },
  model: {
    prop: 'active',
    event: 'close',
  },
  props: {
    stepsCount: {
      type: Number,
      required: true,
    },
    currentStep: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    description: {
      type: String,
      required: false,
      default: '',
    },
    active: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style scoped>
.stepped-modal {
  justify-content: start;
  z-index: 100;
  height: 100vh;
}

.stepped-modal::v-deep .modal-content {
  min-height: 100vh;
}

.stepped-modal .inner {
  display: grid;
  grid-template-rows: min-content min-content auto;
  grid-template-areas:
    'steps'
    'header'
    'content';
}

.stepped-modal-heading {
  grid-area: header;
}

.stepped-modal-content {
  grid-area: content;
}

.stepped-modal-steps {
  grid-area: steps;
}

@media (min-width: 1280px) {
  .stepped-modal {
    justify-content: center;
  }

  .stepped-modal::v-deep .modal-content {
    min-height: auto;
  }

  .stepped-modal .inner {
    grid-template-rows: min-content auto min-content;
    grid-template-areas:
      'header'
      'content'
      'steps';
  }
}
</style>
